"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFrameProductEditViewModel = instanceOfFrameProductEditViewModel;
exports.FrameProductEditViewModelFromJSON = FrameProductEditViewModelFromJSON;
exports.FrameProductEditViewModelFromJSONTyped = FrameProductEditViewModelFromJSONTyped;
exports.FrameProductEditViewModelToJSON = FrameProductEditViewModelToJSON;
exports.FrameProductEditViewModelToJSONTyped = FrameProductEditViewModelToJSONTyped;
/**
 * Check if a given object implements the FrameProductEditViewModel interface.
 */
function instanceOfFrameProductEditViewModel(value) {
    if (!('fpFrameNo' in value) || value['fpFrameNo'] === undefined)
        return false;
    if (!('fpPrice' in value) || value['fpPrice'] === undefined)
        return false;
    return true;
}
function FrameProductEditViewModelFromJSON(json) {
    return FrameProductEditViewModelFromJSONTyped(json, false);
}
function FrameProductEditViewModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fpNo': json['fpNo'] == null ? undefined : json['fpNo'],
        'fpFrameNo': json['fpFrameNo'],
        'fpPrice': json['fpPrice'],
        'fpStatus': json['fpStatus'] == null ? undefined : json['fpStatus'],
    };
}
function FrameProductEditViewModelToJSON(json) {
    return FrameProductEditViewModelToJSONTyped(json, false);
}
function FrameProductEditViewModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'fpNo': value['fpNo'],
        'fpFrameNo': value['fpFrameNo'],
        'fpPrice': value['fpPrice'],
        'fpStatus': value['fpStatus'],
    };
}
